var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoveInStockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_106_7",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_106_7",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAACk0lEQVR4nO3dv2oUURiG8dVIEC/BKmoh2ESwE0GjFyAWgoXapLIPbidBjMZGC70BiSha5QbEauMNpBHtBMFGsPXPPnJ0xBU2mzG637w53/uDacM582Rnzk7CnF7PzMzMzMzMzMwsGeAwcBVYAvpJjiXgCnCopwI4C7zCNoCFLkPsBe64wx+GwEo5N10EcYytrXRxmSq/DTbeMPTy5XtGKxtRMebajceIWH01S1tr53JEkLL+tnb6EUGWWw7GYNlBtDiIGAcRU12QR8A8MPsfxj0LHAfWAsdfVZAbFcyhmiBvgJkpzmEf8DZgHtUEeRAwj4cB86gmyGrAPO4GzKOaIC8C5vEyYB7VBBlO8/E1cC7ozwfVBCk+AuenMP4Lzc+OUFWQ0RXXOvD8H4/1oJVV9UF2MwcR4yBiHESMg4hxEDEOIsZBxDiIGAcRkyrIB+Ae8Bj4hqY0QT4DR0fGdAn4ip40QV6PGZdilDRBNrcY20XgCzpyBxGM4iBiURxELIqDiEVxELEoDiIWJSTIQeBEx8exHYy7i+8p0w+ym/EzSuRjFgfZDnDfQYQARxxECLA/8C0UvmRtBzjpT4gIYAYYOIhOjLXAGDGXLOCUwJvcFncQ40lwjLAg0o/fRT4ZvziIUAwHEYvhIGIxHEQsRpH7HoJWjNxB0IuRKsi7MTGeoidNkOJaM54DwDM0pQpSvAc+oStdEHUOIsZBxDiIGAcR4yAZg/hV4+1djwjil/GLvYzf21W0F7NZWNms5C8GldUgJEYTZMFbHk1U/hHvdFiQJsrtyWNK7WZojJFt88oWcd4c7LdyLm4Be8KDjIQ543vKD4Pwy9QkZUVRlnnN95TVJEe/mfNc1+ffzMzMzMzMzMysF+w7rur2mvVdFzEAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveInStockIcon);
export default __webpack_public_path__ + "static/media/moveInStockIcon.3cef5eeab12a7632bcf7f99f5a48d842.svg";
export { ForwardRef as ReactComponent };